import { render, staticRenderFns } from "./DealImageEdit.vue?vue&type=template&id=d3cdf186&"
import script from "./DealImageEdit.vue?vue&type=script&lang=ts&"
export * from "./DealImageEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports